<template>
    <el-form ref="form" :model="form" label-width="10%">

        <div align="center">
            <span style=" margin-left: 5px; color: dodgerblue; padding: 5px; ">{{form.tenant_name}}</span>
        </div>

        <el-row :gutter="24" style="margin-top: 10px">

            <el-col :span="12">
                <div align="left" style="margin-left: 30px">
                    <span style=" color: gainsboro; font-size: 14px">制单人：</span>
                    <span style=" color: gainsboro; font-size: 14px">{{form.create_name}}</span>
                </div>

            </el-col>
            <el-col :span="12">
                <div align="right">
                    <div align="right">
                        <span style=" color: gainsboro; padding: 5px;  font-size: 14px">日期：</span>
                        <span style=" color: gainsboro; padding: 5px;  font-size: 14px">{{form.date}}</span>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-form-item label="服务人员" style="margin-top: 20px">
            <span style="color: dodgerblue">{{obj.alias + ' ' + obj.phone}}</span>
        </el-form-item>


        <el-form-item label="服务内容">
            <el-input disabled
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 10}"
                    placeholder="请输入服务内容的描述"
                    v-model="form.service_content">
            </el-input>
        </el-form-item>

        <el-form-item label="详情描述">
            <el-input disabled
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 10}"
                    placeholder="请输入服务过程的描述"
                    v-model="form.service_describe">
            </el-input>
        </el-form-item>

        <el-form-item label="完工日期">
            <div class="block">
                <el-date-picker disabled
                        v-model="form.completion_date"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </div>
        </el-form-item>


        <el-form-item label="完工前">
            <el-upload disabled
                    action="https://api.retailstore365.com:15041/uploadphoto"
                    :http-request="uploadFourthBackFun"
                    list-type="picture-card"
                    :show-file-list="true" multiple
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleImgSuccess"
                    :before-upload="beforeFourthBackImgUpload"
                    :on-remove="handleFourthBackRemove"
                    :file-list="form.backFileList">
                <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!--<el-dialog :visible.sync="dialogVisible">-->
            <!--<img width="100%" :src="dialogImageUrl" alt="">-->
            <!--</el-dialog>-->
        </el-form-item>


        <el-form-item label="完工后">
            <el-upload disabled
                    action="https://api.retailstore365.com:15041/uploadphoto"
                    :http-request="uploadFourthBeforeFun"
                    list-type="picture-card"
                    :show-file-list="true" multiple
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleImgSuccess"
                    :before-upload="beforeFourthBeforeImgUpload"
                    :on-remove="handleFourthBeforeRemove"
                    :file-list="form.beforeFileList">
                <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!--<el-dialog :visible.sync="dialogVisible">-->
            <!--<img width="100%" :src="dialogImageUrl" alt="">-->
            <!--</el-dialog>-->
        </el-form-item>

        <el-row :gutter="24" style="margin-top: 10px">
            <el-col :span="12">
                <div align="left" style="margin-left: 20px">
                    <span style=" color: gainsboro; padding: 5px; font-size: 14px">服务项目</span>
                </div>
            </el-col>
            <el-col :span="12">
                <div align="right">

                </div>
            </el-col>
        </el-row>

        <el-form-item label="服务评价" style="margin-top: 20px">
            <!--el-form-item label="服务内容">-->
            <el-input :disabled="obj.status !== 'AWAIT'"
                    style="color: dodgerblue"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 10}"
                    placeholder="请输入服务内容的描述"
                    v-model="form.store_service_content">
            </el-input>
            <!--<span style="color: dodgerblue">{{fourthForm.store_service_content}}</span>-->
        </el-form-item>

        <el-form-item label="服务评级">


            <el-rate style="margin-top: 10px" :allow-half="true"  :disabled="obj.status !== 'AWAIT'"
                     v-model="form.store_service_stars"
                     show-score
                     allow-half
                     text-color="#ff9900"
                     score-template="{value}">
            </el-rate>


        </el-form-item>
        <el-form-item label="客户照片">
            <el-upload  :disabled="obj.status !== 'AWAIT'"
                    action="https://api.retailstore365.com:15041/uploadphoto"
                    :http-request="uploadFourthStoreFun"
                    list-type="picture-card"
                    :show-file-list="true" multiple
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleImgSuccess"
                    :before-upload="beforeFourthStoreImgUpload"
                    :on-remove="handleFourthStoreRemove"
                    :file-list="form.storeServiceFileList">
                <i class="el-icon-plus avatar-uploader-icon"></i>

            </el-upload>
            <!--<el-dialog :visible.sync="dialogVisible">-->
            <!--<img width="100%" :src="dialogImageUrl" alt="">-->
            <!--</el-dialog>-->
        </el-form-item>
    </el-form>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
//            form: {
//                type: Object,
//                default: () => {
//                }
//            },
//            obj: {
//                type: Object,
//                default: () => {
//                }
//
//            }
        },
        components: {},
        data() {
            return {
                form: {
                    receipt_status: '',
                    created_tenant_id: '',
                    create_by: '',
                    create_name: '',
                    tenant_name: '',
                    alias: '',
                    date: '',
                    serviceComments: "",
                    back_photos: [],
                    backFileList: [],
                    before_photos: [],
                    beforeFileList: [],
                    store_service_photos: [],
                    storeServiceFileList: [],
                    completion_date: "",
                    service_content: "",
                    service_describe: "",
                    store_service_content: "",
                    store_service_stars: 0
                },
                obj: {
//                    initiator: "RETAIL"
                    initiator: "SERVICE",
                    created_by: "",
                    account_name: "",
                    store_name: "",
                    alias: "",
                    ticket_id: '',
                    ticket_no: "",
                    phone: "",
                    photo: [],
                    status: "NEW",
                    stepDatas: [{title: "已接单"},
                        {title: "已派单"},
                        {title: "进行中"},
                        {title: "已完工"},
                        {title: "已评价"}],
                    reference_obj : ''

                },
            }
        },
        computed: {},
        created() {

        },
        methods: {
            setInfo(data) {
                this.form.alias = data.alias
                this.form.tenant_name = data.tenant_name
                this.form.create_name = data.create_name
                this.form.create_by = data.create_by
                this.form.date = data.date
                this.form.serviceComments = data.serviceComments

                this.form.back_photos = data.back_photos == null ? [] : data.back_photos
                this.form.backFileList = data.backFileList == null ? [] : data.backFileList
                this.form.before_photos = data.before_photos == null ? [] : data.before_photos
                this.form.beforeFileList = data.beforeFileList == null ? [] : data.beforeFileList
                this.form.store_service_photos = data.store_service_photos == null ? [] : data.store_service_photos
                this.form.storeServiceFileList = data.storeServiceFileList == null ? [] : data.storeServiceFileList

                this.form.completion_date = data.completion_date
                this.form.service_content = data.service_content
                this.form.service_describe = data.service_describe
                this.form.store_service_content = data.store_service_content
                this.form.store_service_stars = data.store_service_stars
                this.form.created_tenant_id = data.created_tenant_id
                this.form.receipt_status = data.receipt_status
            },
            getInfo(){
                var obj = {}
                obj.tenant_name = this.form.tenant_name
                obj.create_name = this.form.create_name
                obj.create_by = this.form.create_by
                obj.date = this.form.date
                obj.serviceComments = this.form.serviceComments
                obj.back_photos = this.form.back_photos
                obj.backFileList = this.form.backFileList
                obj.before_photos = this.form.before_photos
                obj.beforeFileList = this.form.beforeFileList
                obj.store_service_photos = this.form.store_service_photos
                obj.storeServiceFileList = this.form.storeServiceFileList
                obj.completion_date = this.form.completion_date
                obj.service_content = this.form.service_content
                obj.service_describe = this.form.service_describe
                obj.store_service_content = this.form.store_service_content
                obj.store_service_stars = this.form.store_service_stars
                obj.created_tenant_id = this.form.created_tenant_id
                obj.receipt_status = this.form.receipt_status
                return obj
            },
            getObj(data) {
                this.obj = data
            },


            showInfo(index, row) {
                this.$emit('showInfo', row)

            },

            async uploadFourthBackFun(param) {
                var user = this.$store.getters.getUser


                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', user.reference_obj);
                data.append('reference_id', user.reference_id);
                data.append('credential', user.client_secret);
                data.append('username', user.username);
                data.append('tenant_id', user.tenant_id);
                data.append('user_id', user.user_id);
                data.append('category', 'USER');
                data.append('size', '300');

                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头

                let res = await http.post(param.action, data)
                if (res.success) {
                    var s3filename = res.data.s3filename
                    var obj = this.form.back_photos[this.form.back_photos.length-1]
                    obj.file_id = s3filename
                }
            },
            async uploadFourthBeforeFun(param) {
                var user = this.$store.getters.getUser


                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', user.reference_obj);
                data.append('reference_id', user.reference_id);
                data.append('credential', user.client_secret);
                data.append('username', user.username);
                data.append('tenant_id', user.tenant_id);
                data.append('user_id', user.user_id);
                data.append('category', 'USER');
                data.append('size', '300');

                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头

                let res = await http.post(param.action, data)
                if (res.success) {
                    var s3filename = res.data.s3filename
                    var obj = this.form.before_photos[this.form.before_photos.length-1]
                    obj.file_id = s3filename
                }
            },
            async uploadFourthStoreFun(param) {
                var user = this.$store.getters.getUser


                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', user.reference_obj);
                data.append('reference_id', user.reference_id);
                data.append('credential', user.client_secret);
                data.append('username', user.username);
                data.append('tenant_id', user.tenant_id);
                data.append('user_id', user.user_id);
                data.append('category', 'USER');
                data.append('size', '300');

                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头

                let res = await http.post(param.action, data)
                if (res.success) {
                    var s3filename = res.data.s3filename

                    var obj = this.form.store_service_photos[this.form.store_service_photos.length-1]
                    obj.file_id = s3filename
                }
            },

            handlePictureCardPreview(file) {
                this.$emit('showImageAction', {
                    showImageUrl: file.url,
                    showImage: true
                })
            },
            // 上传图片成功
            handleImgSuccess(res, file) {

            },
            // 上传图片前的验证
            beforeFourthBackImgUpload(file) {

                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                else {
                    this.form.back_photos.push({uid: file.uid, file_id: ''})
                }

                return isPic
            },
            // 上传图片前的验证
            beforeFourthBeforeImgUpload(file) {
                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                else {
                    this.form.before_photos.push({uid: file.uid, file_id: ''})
                }

                return isPic
            },
            // 上传图片前的验证
            beforeFourthStoreImgUpload(file) {


                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                else {
                    this.form.store_service_photos.push({uid: file.uid, file_id: ''})
                }

                return isPic
            },
            handleFourthBackRemove(file, fileList) {

                console.log(file, fileList);
                for (var i = 0; i < this.form.back_photos.length; i++) {
                    var obj = this.form.back_photos[i]
                    if (obj.uid == file.uid) {
                        this.form.back_photos.splice(i, 1)
                        return
                    }
                }
            },
            handleFourthBeforeRemove(file, fileList) {

                console.log(file, fileList);
                for (var i = 0; i < this.form.before_photos.length; i++) {
                    var obj = this.form.before_photos[i]
                    if (obj.uid == file.uid) {
                        this.form.before_photos.splice(i, 1)
                        return
                    }
                }
            },
            handleFourthStoreRemove(file, fileList) {

                console.log(file, fileList);
                for (var i = 0; i < this.form.store_service_photos.length; i++) {
                    var obj = this.form.store_service_photos[i]
                    if (obj.uid == file.uid) {
                        this.form.store_service_photos.splice(i, 1)
                        return
                    }
                }
            },
        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/form/fourthForm.vue